import { ca } from '@cian/analytics';

export const trackNewbuildingLayoutDetailsOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Layout',
    action: 'show_sopr',
    label: 'modal_open',
  });
};
